import Icon from "@core-components/icon/Icon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Stack, Text } from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import type { ReactNode } from "react";
import { Link } from "react-router";
import type { IReview } from "./model/IReview";

const Review = ({ grade, author, comment, url }: IReview) => {
  const { t } = useAppTranslation();

  const getGrade = () => {
    if (grade > 5) {
      grade = 5;
    } else if (grade < 0) {
      grade = 0;
    }

    return (
      <Group gap={5}>
        {Array.from({ length: grade }).map((_, index) => (
          <Icon.TrustpilotStartFilled key={index} size={20} />
        ))}
        {Array.from({ length: 5 - grade }).map((_, index) => (
          <Icon.TrustpilotStartOutlined key={index} size={20} />
        ))}
      </Group>
    );
  };

  const Wrapper = ({ children }: { children: ReactNode }) => {
    return url ? (
      <Link
        className="gradient-primary-from-top hover-scale h-full rounded-2xl p-7 no-underline"
        to={url}
        target="_blank"
      >
        <Stack>{children}</Stack>
      </Link>
    ) : (
      <Stack className="gradient-primary-from-top hover-scale h-full rounded-2xl p-7">
        {children}
      </Stack>
    );
  };

  return (
    <Wrapper>
      <AppSkeleton>{getGrade()}</AppSkeleton>
      <AppSkeleton>
        <Text className="font-secret-black text-[22px] text-primary-white">
          {author.toUpperCase()}
        </Text>
      </AppSkeleton>

      <AppSkeleton fullWidth={false} radius="xl">
        <Text
          className="font-inter font-light text-primary-dark-text text-sm"
          lineClamp={4}
        >
          {t(comment)}
        </Text>
      </AppSkeleton>
    </Wrapper>
  );
};

export default Review;
